import './Needs.css'

const Needs = () =>{
    return (
        <>
        
        <div className="needsbg">
            <div className='container needcontent' >
                <h4 className='needhead' >Why You Need a Website?</h4>
                <p className='needpara'>Essentially, anyone looking to establish an online presence, share information, or engage with a community can benefit from having a website.
In today’s digital age, a simple static website can act as a business card, and a dynamic website can take the place of a storefront. They both allow you to share information with a global audience 24/7.
</p>
            </div>
        </div>
        </>
        );
}

export default Needs